import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TID } from "@/lib/testIds";

const langs = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={TID.langSwitcher}
        className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md text-xs border border-transparent hover:border-[color:var(--border)] transition-colors"
      >
        <Globe size={14} />
        <span className="uppercase tracking-wider">{current}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-opt-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className={current === l.code ? "font-medium text-[color:var(--brand)]" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
